export default __webpack_public_path__ + "static/media/email.9b36cb54.svg";